import { client } from '../../lib/urql';
import { UPLOAD_TOKEN_V2_QUERY } from '../../../graphql/auth/uploadToken.query';

export const getUploadTokenV2 = async () => {
  const response = await client.query({
    query: UPLOAD_TOKEN_V2_QUERY,
    fetchPolicy: 'network-only',
  });

  return response.data.uploadTokenV2;
};
